import axios from "axios";
let baseURL = "";

let http = axios.create({
  baseURL: '/api',
  timeout: 10000,
});

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    this.$message({
      message: "网络错误",
      type: "warning",
    });
    console.log(err);
  }
);

// 响应拦截器
http.interceptors.response.use(
  (Response) => {
    if (Response.data.status === -1) {
      this.$message({
        message: Response.data.msg,
        type: "warning",
      });
    } else if (Response.data.status === 0) {
      this.$message({
        message: Response.data.msg,
        type: "warning",
      });
    } else if (Response.data.status) {
      return Response.data;
    }
  },
  (error) => {
    console.error(error, "error");
  }
);

// post请求
const post = (url, data) => http.post(url, data);
const get = (url, data) => http.get(url, {
  params: { ...data }
});

export default { post, get, baseURL };
